"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTaxes = exports.deleteTaxGroup = exports.updateTaxGroup = exports.addTaxGroup = exports.getTaxGroups = void 0;
const shared_1 = require("@getgreenline/shared");
const getTaxGroups = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/taxGroups`);
    return response.data.taxGroups;
});
exports.getTaxGroups = getTaxGroups;
const addTaxGroup = (companyId, createObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v1/company/${companyId}/taxGroup`, createObject);
    return response.data;
});
exports.addTaxGroup = addTaxGroup;
const updateTaxGroup = (companyId, taxGroupId, updateObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/taxGroup/${taxGroupId}`, updateObject);
    return response.data;
});
exports.updateTaxGroup = updateTaxGroup;
const deleteTaxGroup = (companyId, taxGroupId) => __awaiter(void 0, void 0, void 0, function* () {
    return yield shared_1.axios.delete(`/api/v1/company/${companyId}/taxGroup/${taxGroupId}`);
});
exports.deleteTaxGroup = deleteTaxGroup;
const getTaxes = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/taxes`);
    return response.data.taxes;
});
exports.getTaxes = getTaxes;
//# sourceMappingURL=taxes.js.map